interface HomeScreenProps {
  content: React.ReactNode;
  children: React.ReactNode;
}

const HomeScreen = ({ content, children }: HomeScreenProps) => {
  const leftPanel = (
    <div className="hidden md:flex md:w-1/2 bg-brand-600 items-center justify-center relative p-8">
      <div className="text-white z-10">
        {content}
      </div>
      <img
        src="/login.jpg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-90"
        onError={(e) => {
          e.currentTarget.style.display = 'none';
        }}
      />
    </div>
  );

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <div className="flex-1 flex flex-col md:flex-row">
        {leftPanel}
        <div className="w-full md:w-1/2 flex items-center justify-center p-8">
          {children}
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;
